import React from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { bool, object, func } from 'prop-types';

// Import validation
import validation from './validate';

// Import components
import { Button } from 'components/elements';
import PhoneNumberFormFields from './PhoneNumberFormFields';

// Import styles
import { SmsInfo } from 'components/views/authentication/login/firebase_auth/style';

const PhoneNumberForm = ({
	onSubmit,
	isRecaptchaSuccess,
	formRef,
	initialValues
}) => {
	const { t } = useTranslation();

	return (
		<Formik
			ref={formRef}
			initialValues={initialValues}
			validate={validation}
			onSubmit={onSubmit}
		>
			{({ handleSubmit, isSubmitting, values }) => (
				<form onSubmit={handleSubmit}>
					<PhoneNumberFormFields
						isSubmitting={isSubmitting}
						values={values}
						formRef={formRef}
					/>
					<SmsInfo>{t('common_login_firebase_sms_info')}</SmsInfo>
					<Button
						type="submit"
						disabled={isSubmitting || !isRecaptchaSuccess}
						width="100%"
						modifiers="primary"
					>
						{t('common_login_firebase_phone_number_submit')}
					</Button>
				</form>
			)}
		</Formik>
	);
};

PhoneNumberForm.propTypes = {
	onSubmit: func.isRequired,
	isRecaptchaSuccess: bool.isRequired,
	formRef: object.isRequired,
	initialValues: object.isRequired
};

export default PhoneNumberForm;
